<div class="thomas-prompts">
  @if (!editing) {
    <div class="thomas-prompts-header">
      <button type="button" class="thomas-header-button" title="Back to the conversation" aria-label="Back to the conversation" (click)="closed.emit()">
        <i class="material-icons">arrow_back</i>
      </button>
      <span class="thomas-prompts-title">Saved prompts</span>
      <button type="button" class="thomas-button-primary small thomas-prompts-add" (click)="add()">
        <i class="material-icons" aria-hidden="true">add</i>
        <span>Add prompt</span>
      </button>
    </div>

    <div class="thomas-prompts-body">
      @if (rows.length) {
        <ul class="thomas-prompt-rows">
          @for (row of rows; track row.id) {
            <li class="thomas-prompt-row" [class.saved]="row.id === savedId">
              <button type="button" class="thomas-prompt-run" [title]="row.text" (click)="send.emit(row.text)">
                <span class="thomas-prompt-name">{{ row.description }}</span>
                <span class="thomas-prompt-meta">
                  <span>{{ row.isCompany ? 'Company' : 'Personal' }} · {{ appsLabel(row.apps) }}</span>
                </span>
              </button>
              @if (canChange(row)) {
                <button type="button" class="thomas-prompt-edit" title="Edit" [attr.aria-label]="'Edit ' + row.description" (click)="edit(row)">
                  <i class="material-icons">edit</i>
                </button>
              }
            </li>
          }
        </ul>
      } @else if (!loading) {
        <div class="thomas-prompts-empty">No saved prompts yet.</div>
      }
    </div>
  } @else {
    <div class="thomas-prompts-header">
      <button type="button" class="thomas-header-button" title="Back to saved prompts" aria-label="Back to saved prompts" (click)="cancel()">
        <i class="material-icons">arrow_back</i>
      </button>
      <span class="thomas-prompts-title">{{ editing.id === null ? 'Add prompt' : 'Edit prompt' }}</span>
    </div>

    <div class="thomas-prompt-editor">
      <div class="thomas-field">
        <label class="thomas-field-label" for="thomas-prompt-title">Title</label>
        <dx-text-box [(value)]="editing.description" stylingMode="outlined" [maxLength]="titleMaxLength" [inputAttr]="{ id: 'thomas-prompt-title' }"
          (onInitialized)="focusEditor($event)" (onEnterKey)="save()">
          <dx-validator [validationGroup]="validationGroup" [validationRules]="titleRules"></dx-validator>
        </dx-text-box>
      </div>

      <div class="thomas-field">
        <label class="thomas-field-label" for="thomas-prompt-text">Prompt</label>
        <dx-text-area [(value)]="editing.text" stylingMode="outlined" valueChangeEvent="input" (onValueChanged)="textEdited($event)" [maxLength]="promptMaxLength" [autoResizeEnabled]="true" [minHeight]="112" [maxHeight]="240"
          [inputAttr]="{ id: 'thomas-prompt-text' }">
          <dx-validator [validationGroup]="validationGroup" [validationRules]="textRules"></dx-validator>
        </dx-text-area>
      </div>

      @if (canManageCompany) {
        <div class="thomas-field" role="group" aria-labelledby="thomas-prompt-scope">
          <span class="thomas-field-label" id="thomas-prompt-scope">Who can use this?</span>
          <dx-radio-group [items]="scopes" valueExpr="value" displayExpr="text" [(value)]="editing.isCompany"></dx-radio-group>
          @if (editing.id !== null && editing.isCompany !== editing.wasCompany) {
            <span class="thomas-field-hint">{{ editing.isCompany ? 'Everyone in the company will see it.' : 'Only you will see it after saving.' }}</span>
          }
        </div>
      }

      <div class="thomas-field" role="group" aria-labelledby="thomas-prompt-apps">
        <div class="thomas-field-row">
          <span class="thomas-field-label" id="thomas-prompt-apps">Show in</span>
          <button type="button" class="thomas-button-quiet" [disabled]="checking || saving" (click)="checkApps()">
            {{ checking ? 'Checking...' : 'Check where it works' }}
          </button>
        </div>
        <div class="thomas-app-checks">
          @for (option of appOptions(); track option.id) {
            <dx-check-box [value]="hasApp(option.id)" [text]="option.name" (onValueChanged)="setApp(option.id, $event.value)"></dx-check-box>
          }
        </div>
        @if (checkNote) {
          <span class="thomas-field-hint" role="status">{{ checkNote }}</span>
        }
        @if (!editing.apps.length) {
          <span class="thomas-field-hint">Tick at least one app.</span>
        }
      </div>
    </div>

    <div class="thomas-prompt-actions">
      @if (editing.id !== null) {
        <button type="button" class="thomas-button-danger" [disabled]="saving" (click)="remove()">Delete</button>
      }
      <span class="thomas-prompt-actions-spacer"></span>
      <button type="button" class="thomas-button-secondary" [disabled]="saving" (click)="cancel()">Cancel</button>
      <button type="button" class="thomas-button-primary" [disabled]="saving || !editing.apps.length" (click)="save()">Save</button>
    </div>
  }
</div>
